import _ from 'lodash';
import { formatAmountWithFraction } from '@riseupil/base-ui/src/utils/formatters';

const state = {
  categories: {},
  initialCategories: {},
};

const mutations = {
  setCategories(state, categories) {
    state.categories = _.cloneDeep(categories);
  },
  setInitialCategories(state, categories) {
    state.initialCategories = _.cloneDeep(categories);
  },
  updateCategoryItem(state, { category, name, amount }) {
    const items = state.categories[category] || [];
    const idx = _.findIndex(items, e => e.name === name);
    if (idx !== -1 && formatAmountWithFraction(amount) !== formatAmountWithFraction(items[idx].amount)) {
      items[idx] = { ...items[idx], amount, changed: true };
      state.categories[category] = [...items];
    }
  },
  resetCategoryItem(state, { category, name }) {
    const items = state.categories[category] || [];
    const idx = _.findIndex(items, e => e.name === name);
    if (idx !== -1) {
      items[idx] = { ...items[idx], amount: items[idx].initialAmount, changed: false };
      state.categories[category] = [...items];
    }
  },
  addNewExpenseItem(state, { category, expense }) {
    const items = state.categories[category] || [];
    items.push(expense);
    state.categories[category] = [...items];
  },
  clearCustomExpenses(state) {
    state.categories.custom = [];
  },
};

const actions = {
  initCategories({ commit }, categories) {
    const updatedCategories = {};

    categories.forEach(({ category, data }) => {
      updatedCategories[category] = data.map(e => ({
        ...e,
        changed: false,
        initialAmount: e.amount,
      }));
    });
    commit('setCategories', updatedCategories);
    commit('setInitialCategories', updatedCategories);
  },
  updateCategoryItemAmount({ commit }, { category, name, amount }) {
    commit('updateCategoryItem', { category, name, amount });
  },
  addNewExpense({ commit }, expense) {
    commit('addNewExpenseItem', {
      category: 'custom',
      expense: { ...expense, changed: false, isNew: true },
    });
  },
  resetCategoryItemChanged({ commit }, { category, name }) {
    commit('resetCategoryItem', { category, name });
  },
  resetAllCategories({ commit, state }) {
    commit('setCategories', state.initialCategories);
    commit('clearCustomExpenses');
  },
};

const getters = {
  getCategory: state => category => state.categories[category] || [],
  hasChangedItems: state => _.chain(state.categories)
    .values()
    .flatten()
    .some(e => e.changed)
    .value(),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
